import { render, staticRenderFns } from "./CheckboxArrayObjectValue.vue?vue&type=template&id=4699198e&"
import script from "./CheckboxArrayObjectValue.vue?vue&type=script&lang=js&"
export * from "./CheckboxArrayObjectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports